(function () {
  'use strict';

  if (window.__VSKLO_PREMIUM_MODULAR_ASSEMBLY_V1__) return;
  window.__VSKLO_PREMIUM_MODULAR_ASSEMBLY_V1__ = true;

  var mobile = window.matchMedia('(max-width: 749px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = [];
  var ticking = false;

  var verticalParts = [
    { sy: 56, h: 103, start: 0, end: 0 },
    { sy: 166, h: 121, start: 110, end: 96 },
    { sy: 295, h: 76, start: 239, end: 210 },
    { sy: 376, h: 21, start: 320, end: 279 },
    { sy: 400, h: 71, start: 344, end: 293 },
    { sy: 474, h: 23, start: 418, end: 357 },
    { sy: 507, h: 72, start: 451, end: 373 },
    { sy: 583, h: 23, start: 527, end: 438 },
    { sy: 614, h: 98, start: 558, end: 454 },
    { sy: 735, h: 119, start: 679, end: 545 }
  ];

  /* Coordinates of parts in 2048x1152 horizontal WebP, after its product strip is rotated. */
  var horizontalParts = [
    { sy: 0, h: 234, start: 0, end: 0 },
    { sy: 245, h: 319, start: 245, end: 220 },
    { sy: 586, h: 164, start: 586, end: 525 },
    { sy: 759, h: 50, start: 759, end: 680 },
    { sy: 829, h: 163, start: 829, end: 720 },
    { sy: 1008, h: 48, start: 1008, end: 874 },
    { sy: 1070, h: 164, start: 1070, end: 912 },
    { sy: 1253, h: 54, start: 1253, end: 1067 },
    { sy: 1324, h: 164, start: 1324, end: 1111 },
    { sy: 1506, h: 56, start: 1506, end: 1266 },
    { sy: 1581, h: 234, start: 1581, end: 1312 }
  ];

  /* Tight 251x1931 vertical WebP for the "2 glasses + decanter" set. */
  var decanterParts = [
    { sy: 36, h: 235, start: 36, end: 0 },
    { sy: 282, h: 326, start: 282, end: 220 },
    { sy: 630, h: 166, start: 630, end: 538 },
    { sy: 805, h: 51, start: 805, end: 698 },
    { sy: 875, h: 166, start: 875, end: 741 },
    { sy: 1057, h: 48, start: 1057, end: 899 },
    { sy: 1121, h: 443, start: 1121, end: 939 },
    { sy: 1580, h: 57, start: 1580, end: 1376 },
    { sy: 1659, h: 237, start: 1659, end: 1425 }
  ];

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
  function ease(value) {
    return value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function scaledParts(parts, scale) {
    return parts.map(function (part) {
      var copy = {};
      Object.keys(part).forEach(function (key) { copy[key] = part[key]; });
      copy.sy *= scale;
      copy.h *= scale;
      copy.start *= scale;
      copy.end *= scale;
      return copy;
    });
  }

  function prepareDecanterSource(image) {
    if (image.naturalWidth <= image.naturalHeight) {
      var verticalScale = image.naturalHeight / 1931;
      return {
        image: image,
        width: image.naturalWidth,
        height: image.naturalHeight,
        finalHeight: 1662 * verticalScale,
        parts: scaledParts(decanterParts, verticalScale)
      };
    }

    /* Also accepts the supplied tight horizontal 1931x251 file. */
    var rotated = document.createElement('canvas');
    rotated.width = image.naturalHeight;
    rotated.height = image.naturalWidth;
    var context = rotated.getContext('2d');
    context.translate(image.naturalHeight, 0);
    context.rotate(Math.PI / 2);
    context.drawImage(image, 0, 0);
    var horizontalScale = image.naturalWidth / 1931;

    return {
      image: rotated,
      width: rotated.width,
      height: rotated.height,
      finalHeight: 1662 * horizontalScale,
      parts: scaledParts(decanterParts, horizontalScale)
    };
  }

  function prepareSource(image, layout) {
    if (layout === 'two-glasses-decanter') return prepareDecanterSource(image);

    if (image.naturalWidth <= image.naturalHeight) {
      return { image: image, width: 307, height: 916, finalHeight: 664, parts: verticalParts };
    }

    var scaleX = image.naturalWidth / 2048;
    var scaleY = image.naturalHeight / 1152;
    var cropX = Math.round(103 * scaleX);
    var cropY = Math.round(480 * scaleY);
    var cropWidth = Math.round(1815 * scaleX);
    var cropHeight = Math.round(210 * scaleY);
    var rotated = document.createElement('canvas');
    rotated.width = cropHeight;
    rotated.height = cropWidth;
    var context = rotated.getContext('2d');

    context.translate(cropHeight, 0);
    context.rotate(Math.PI / 2);
    context.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

    return {
      image: rotated,
      width: cropHeight,
      height: cropWidth,
      finalHeight: 1546 * scaleX,
      parts: scaledParts(horizontalParts, scaleX)
    };
  }

  function buildLabels(instance) {
    if (!instance.labels || !instance.source) return;
    instance.labels.textContent = '';
    instance.labelItems = instance.source.parts.map(function (part, index) {
      var label = document.createElement('span');
      var number = document.createElement('strong');
      label.className = 'vps-assembly__part-label';
      number.className = 'vps-assembly__part-number';
      number.textContent = index + 1;
      label.appendChild(number);
      var labelText = instance.labelTexts && instance.labelTexts[index] || '';
      if (labelText) label.appendChild(document.createTextNode('. ' + labelText));
      instance.labels.appendChild(label);
      return label;
    });
  }

  function loadImage(instance, src, allowFallback) {
    var image = new Image();
    image.onload = function () {
      instance.source = prepareSource(image, instance.wrapper.dataset.assemblyLayout || 'four-glasses');
      instance.canvasCssHeight = null;
      buildLabels(instance);
      requestRender();
    };
    image.onerror = function () {
      if (allowFallback && instance.wrapper.dataset.fallbackSrc && src !== instance.wrapper.dataset.fallbackSrc) {
        loadImage(instance, instance.wrapper.dataset.fallbackSrc, false);
      }
    };
    image.src = src;
  }

  function draw(instance, progress) {
    if (!instance.source) return;
    var source = instance.source;
    var canvas = instance.canvas;
    var context = instance.context;
    var ratio = Math.min(window.devicePixelRatio || 1, 2);
    if (!instance.canvasCssHeight) {
      var availableHeight = Math.max(320, instance.stage.clientHeight * .94);
      instance.canvasCssHeight = Math.min(availableHeight, 720);
    }
    var cssHeight = instance.canvasCssHeight;
    var cssWidth = cssHeight * source.width / source.finalHeight;
    var canvasOffset = parseFloat(
      window.getComputedStyle(instance.wrapper).getPropertyValue('--vps-assembly-canvas-offset')
    ) || 0;
    var pixelWidth = Math.max(1, Math.round(cssWidth * ratio));
    var pixelHeight = Math.max(1, Math.round(cssHeight * ratio));

    if (canvas.width !== pixelWidth || canvas.height !== pixelHeight) {
      canvas.width = pixelWidth;
      canvas.height = pixelHeight;
      canvas.style.width = cssWidth + 'px';
      canvas.style.height = cssHeight + 'px';
    }

    context.setTransform(pixelWidth / source.width, 0, 0, pixelHeight / source.finalHeight, 0, 0);
    context.clearRect(0, 0, source.width, source.finalHeight);
    var phase = progress * source.parts.length;
    var activeIndex = 0;
    var labelPositions = [];

    source.parts.forEach(function (part, index) {
      var local = index === 0 ? 1 : clamp(phase - index + 1, 0, 1);
      var eased = ease(local);
      var y = part.start + (part.end - part.start) * eased + (index ? (1 - eased) * 100 : 0);
      context.globalAlpha = index === 0 ? 1 : clamp(local * 2.5, 0, 1);
      context.drawImage(source.image, 0, part.sy, source.width, part.h, 0, y, source.width, part.h);
      labelPositions.push({
        visible: local > .08,
        opacity: clamp(local * 2.5, 0, 1),
        top: canvasOffset + (y + part.h / 2) / source.finalHeight * cssHeight
      });
      if (local > .35) activeIndex = index;
    });

    context.globalAlpha = 1;
    instance.step.textContent = (activeIndex + 1) + ' / ' + source.parts.length;
    if (instance.labels && instance.labelItems) {
      instance.labels.style.setProperty('--assembly-canvas-half', cssWidth / 2 + 'px');
      var previousTop = 8;
      labelPositions.forEach(function (position, index) {
        var labelTop = Math.max(position.top, previousTop + 21);
        previousTop = position.visible ? labelTop : previousTop;
        instance.labelItems[index].style.top = labelTop + 'px';
        instance.labelItems[index].style.opacity = position.visible ? position.opacity.toFixed(3) : '0';
      });
    }
    instance.progress.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
  }

  function update(instance) {
    if (!mobile.matches) {
      instance.scene.classList.remove('is-pinned', 'is-after');
      return;
    }

    var wrapper = instance.wrapper;
    var scene = instance.scene;
    var rect = wrapper.getBoundingClientRect();
    var topOffset = parseFloat(getComputedStyle(wrapper).getPropertyValue('--vps-assembly-sticky-top')) || 72;
    var viewportWidth = Math.round(window.innerWidth);

    /* Mobile browser chrome changes innerHeight while scrolling. Keep the scene
       dimensions stable and only rebuild them after a real width/orientation change. */
    if (!instance.sceneHeight || Math.abs(viewportWidth - instance.viewportWidth) > 2) {
      instance.viewportWidth = viewportWidth;
      instance.viewportHeight = window.innerHeight;
      instance.sceneHeight = Math.max(420, instance.viewportHeight - topOffset);
      instance.canvasCssHeight = null;
    }

    var sceneHeight = instance.sceneHeight;
    var travel = Math.max(1, wrapper.offsetHeight - sceneHeight);
    var progress = reducedMotion.matches ? 1 : clamp((topOffset - rect.top) / travel, 0, 1);
    var pinned = rect.top <= topOffset && rect.bottom >= topOffset + sceneHeight;

    scene.classList.toggle('is-pinned', pinned);
    scene.classList.toggle('is-after', !pinned && rect.top < topOffset);
    scene.style.setProperty('--assembly-left', rect.left + 'px');
    scene.style.setProperty('--assembly-width', rect.width + 'px');
    scene.style.setProperty('--assembly-top', topOffset + 'px');
    scene.style.setProperty('--assembly-height', sceneHeight + 'px');
    draw(instance, progress);
  }

  function render() { ticking = false; instances.forEach(update); }
  function requestRender() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(render);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vps-modular-section]').forEach(function (root) {
      if (root.dataset.vpsAssemblyReady === 'true') return;
      var wrapper = root.querySelector('[data-vps-assembly]');
      if (!wrapper) return;
      var canvas = wrapper.querySelector('[data-vps-assembly-canvas]');
      var scene = wrapper.querySelector('[data-vps-assembly-sticky]');
      var stage = wrapper.querySelector('[data-vps-assembly-stage]');
      if (!canvas || !scene || !stage) return;

      var labelSource = wrapper.querySelector('[data-vps-assembly-label-source]');
      var labelTexts = [];

      try {
        labelTexts = JSON.parse(
          labelSource && labelSource.textContent
            ? labelSource.textContent
            : '[]'
        );
      } catch (error) {
        labelTexts = [];
      }

      /*
      * Theme blocks
      */
      if (!Array.isArray(labelTexts) || !labelTexts.length) {
        var modularSection = wrapper.closest('.vps-modular');

        labelTexts = Array.prototype.slice
          .call(
            modularSection
              ? modularSection.querySelectorAll(
                  '.vps-modular__points .vps-module-point span'
                )
              : []
          )
          .map(function (label) {
            return label.textContent.trim();
          })
          .filter(Boolean);
      }

      root.dataset.vpsAssemblyReady = 'true';
      var instance = {
        root: root, wrapper: wrapper, scene: scene, stage: stage, canvas: canvas,
        context: canvas.getContext('2d'), step: wrapper.querySelector('[data-vps-assembly-step]'),
        progress: wrapper.querySelector('[data-vps-assembly-progress]'),
        labels: wrapper.querySelector('[data-vps-assembly-labels]'), labelTexts: labelTexts, labelItems: [], source: null,
        viewportWidth: Math.round(window.innerWidth), viewportHeight: window.innerHeight,
        sceneHeight: null, canvasCssHeight: null
      };
      instances.push(instance);
      loadImage(instance, wrapper.dataset.imageSrc || wrapper.dataset.fallbackSrc, true);
    });
    requestRender();
  }

  window.addEventListener('scroll', requestRender, { passive: true });
  window.addEventListener('resize', requestRender, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (instance) { return !event.target.contains(instance.root); });
  });
}());
